// hooks/team/useProductivityTable.js
import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const productivityTableQueryDefaults = {
  staleTime: 1000 * 60 * 5,     // 5 minutes
  gcTime: 1000 * 60 * 30,       // 30 minutes cache
  retry: 2,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
};

export const useProductivityTable = (startDate, endDate) => {
  const {
    data: productivityData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['productivityTable', startDate, endDate],
    queryFn: async () => {
      const startTime = performance.now();
      
      const response = await apiService.get(ENDPOINTS.TIME_PRODUCTIVITY_TABLE, {
        period_type: 'custom',
        start_date: startDate,
        end_date: endDate
      });
            
      return response;
    },
    enabled: !!(startDate && endDate),
    ...productivityTableQueryDefaults,
  });

  return {
    // Data
    productivityData,
    entries: productivityData?.entries || [],
    summary: productivityData?.summary || {},
    summaryStats: productivityData?.summary?.summary_stats || productivityData?.summary || {},
    
    // Loading states
    loading: isLoading,
    refreshing: isFetching,
    
    // Error handling
    error: isError ? (error?.message || 'Failed to load productivity data') : null,
    isError,
    
    // Status
    initialized: !!productivityData,
    hasData: !!(startDate && endDate),
    
    // Actions
    refetch,
  };
};